import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

/* Media module functions */
(function($) {
    'use strict'

    /* Section media */
    gsap.registerPlugin(ScrollTrigger) 

    document.querySelectorAll( '.section-media' ).forEach( (section) => {
        let mediaElem = section.querySelectorAll('.media')

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top bottom-=33%',
                scrub: false,
                markers: false
            }
        })

        tl
            .addLabel('start')
            .to(
                mediaElem,
                { 
                    scale: () => 1,
                    duration: 1.75,
                    repeat: -1,
                    repeatDelay: 15,
                    yoyo: true,
                    ease: 'power2.out'
                }
            )
            .addLabel('end')
    })
})(jQuery)